import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthorizationService } from 'src/app/core/services/authorization.service';
import { first } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})

export class VerifyEmailComponent implements OnInit {
  submitted = null;
  verifyForm: FormGroup;
  email: string;
  code: string;
  lightScrollbarOptions = { axis: 'y', theme: 'light-thick' };
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  validated: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private verifyService: AuthorizationService,
    private formBuilder: FormBuilder
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.email = this.route.snapshot.queryParamMap.get('email'),
      this.code = this.route.snapshot.queryParamMap.get('resetCode')
  }

  ngOnDestroy() { }

  createForm() {
    this.verifyForm = this.formBuilder.group({
      termsAndConditions: [0, Validators.required]
    });
  }

  get f() { return this.verifyForm.controls }

  onSubmit() {
    this.submitted = false;
    if (this.verifyForm.invalid) {
      return
    }
    this.submitted = true;
    if (this.verifyForm.valid) {
      const params = {
        email: this.email,
        resetCode: this.code
      };
      this.verifyService.validateEmail(params)
        .pipe(first())
        .takeUntil(componentDestroyed(this))
        .subscribe((res) => {
          this.validated = true;
        });
    }
  }
}
